import { SupportApiFactory } from 'generated';
import { instanceApi } from 'utils/axios';

const supportApi = SupportApiFactory(undefined, '', instanceApi);

export default supportApi;
